import { combineReducers } from 'redux';

import type { Section } from 'models';

import { FETCH_ACADEMIC_SUCCESS } from '../../../../constants';

type AcademicAction = {
  type: typeof FETCH_ACADEMIC_SUCCESS;
  payload: {
    entities: {
      sections: Record<string, Section>;
    };
  };
};

export const byId = (
  state: Record<string, Section> = {},
  action: AcademicAction,
) => {
  switch (action.type) {
    case FETCH_ACADEMIC_SUCCESS:
      const {
        entities: { sections = {} },
      } = action.payload;
      return sections;
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: AcademicAction) => {
  switch (action.type) {
    case FETCH_ACADEMIC_SUCCESS:
      const {
        entities: { sections = {} },
      } = action.payload;
      return Object.keys(sections);
    default:
      return state;
  }
};

const academic = combineReducers({ byId, ids });

export { academic };
